(() => {
  const sliders = new Map();

  const getNumber = (value, fallback) => {
    const number = Number(value);
    return Number.isFinite(number) ? number : fallback;
  };

  const mountSlider = (container) => {
    if (!window.Splide || sliders.has(container) || container.dataset.layout !== 'carousel') return;

    const sliderElement = container.querySelector('.splide');
    if (!sliderElement) return;

    const slideCount = sliderElement.querySelectorAll('.splide__slide').length;
    const mobileColumns = getNumber(container.dataset.mobileColumns, 2);
    const desktopColumns = getNumber(container.dataset.desktopColumns, 4);
    const gap = getNumber(container.dataset.gap, 16);

    const splide = new Splide(sliderElement, {
      type: slideCount > desktopColumns ? 'loop' : 'slide',
      perPage: desktopColumns,
      perMove: 1,
      gap,
      arrows: slideCount > mobileColumns,
      pagination: false,
      speed: 700,
      easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
      drag: slideCount > mobileColumns,
      keyboard: 'focused',
      breakpoints: {
        767: {
          perPage: mobileColumns,
          gap,
        },
      },
    });

    splide.mount();
    sliders.set(container, splide);
  };

  const mountAll = (scope = document) => {
    scope.querySelectorAll('[data-featured-collection]').forEach(mountSlider);
  };

  const destroySlider = (container) => {
    const splide = sliders.get(container);
    if (!splide) return;

    splide.destroy(true);
    sliders.delete(container);
  };

  document.addEventListener('DOMContentLoaded', () => mountAll());

  document.addEventListener('shopify:section:load', (event) => {
    mountAll(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-featured-collection]').forEach(destroySlider);
  });
})();
